import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_GAMES,
  GAME_MAINTENANCE,
  M_GET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';
import { ISwitchGameMaintenance } from '@/interface/Mainternance';

@Module({ name: 'game' })
export default class Game extends VuexModule {
  game: any = [];

  @Mutation
  mutateGame(game: any) {
    this.game = game;
  }

  @Action({ commit: 'mutateGame' })
  FetchGame() {
    return Vue.axios({
      url: BASE_URL + GET_GAMES,
      method: M_GET,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  SwitchGameMaintenance(params: ISwitchGameMaintenance) {
    return Vue.axios({
      url: BASE_URL + GAME_MAINTENANCE,
      method: M_POST,
      data: params,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
